import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The Robots module provides the following functionalities:`}</p>
    <ul>
      <li parentName="ul">{`contains a router to match application action class for requests to the `}<inlineCode parentName="li">{`robots.txt`}</inlineCode>{` file;`}</li>
      <li parentName="ul">{`allows obtaining the content of the `}<inlineCode parentName="li">{`robots.txt`}</inlineCode>{` file depending on the settings of the current website.`}</li>
    </ul>
    <InlineAlert slots="text" mdxType="InlineAlert" />
The version of this module is 101.1.3.

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      